<div class="mt-4">


    <div class="flex flex-row justify-end items-end gap-5 mr-2">
        <button mat-flat-button class="btn-tg" *ngIf="editIndex === null" (click)="addItemToList()">
            Adicionar
        </button>
    </div>

    <div class="mt-4">
        @if(!loading){

        <div class="mt-4">
            @if (itemsList.length > 0) {
            <div>
                <div class="tab-overflow">
                    <table mat-table [dataSource]="itemsList" class="mat-elevation-z8" cdkDropList
                        (cdkDropListDropped)="drop($event)">
                        <!-- Coluna Local -->
                        <ng-container matColumnDef="localParada">
                            <th mat-header-cell *matHeaderCellDef>Local</th>
                            <td mat-cell *matCellDef="let element; let i = index">
                                <div cdkDrag [cdkDragDisabled]="element.trecho !== 'P'"
                                    class="items-center justify-start flex">
                                    <mat-icon *ngIf="element.trecho === 'P'" cdkDragHandle>drag_indicator</mat-icon>

                                    {{ element.localParada }}
                                </div>
                            </td>
                        </ng-container>

                        <!-- Coluna CEP -->
                        <ng-container matColumnDef="cep">
                            <th mat-header-cell *matHeaderCellDef class="style-header">CEP</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.cep || '-' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Logradouro -->
                        <ng-container matColumnDef="logradouro">
                            <th mat-header-cell *matHeaderCellDef class="style-header">Logradouro</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.logradouro || '-' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Número -->
                        <ng-container matColumnDef="numero">
                            <th mat-header-cell *matHeaderCellDef class="style-header">Número</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.numero || '-' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Bairro -->
                        <ng-container matColumnDef="bairro">
                            <th mat-header-cell *matHeaderCellDef class="style-header">Bairro</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.bairro || '-' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Cidade -->
                        <ng-container matColumnDef="cidade">
                            <th mat-header-cell *matHeaderCellDef class="style-header">Cidade</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.cidade || '-' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Área Tarifária -->
                        <ng-container matColumnDef="areaTarifario">
                            <th mat-header-cell *matHeaderCellDef class="style-header">Área Tarifária</th>
                            <td mat-cell *matCellDef="let element" class="style-row">
                                {{ element.areaTarifario === 'S' ? 'Dentro' : 'Fora' }}
                            </td>
                        </ng-container>

                        <!-- Coluna Ações -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="style-header mat-column-action">Ações</th>
                            <td mat-cell *matCellDef="let element" class="style-row mat-column-action">
                                <div class="flex justify-center items-center gap-3">
                                    <mat-icon class="btn-icon-outline" fontIcon="edit" (click)="startEdit(element)" />
                                    <mat-icon class="btn-icon-outline" fontIcon="delete"
                                        (click)="deleteItem(element)" />
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="style-header"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="style-row"></tr>
                    </table>
                </div>
            </div>
            <!-- <div class="mt-4">
                        <div cdkDropList class="flex flex-col gap-4" 
                            (cdkDropListDropped)="drop($event)">
                            <mat-card *ngFor="let item of itemsList" 
                                cdkDrag 
                                class="custom-card">
                                    <mat-card-title class="text-lg font-bold ">
                                        {{ item.localParada || 'Local não informado' }}
                                    </mat-card-title>
    
                                <mat-card-content class="text-sm text-gray-700">
                                    <p><strong>CEP:</strong> {{ item.cep || '-' }}</p>
                                    <p><strong>Logradouro:</strong> {{ item.logradouro || '-' }}</p>
                                    <p><strong>Número:</strong> {{ item.numero || '-' }}</p>
                                    <p><strong>Bairro:</strong> {{ item.bairro || '-' }}</p>
                                    <p><strong>Cidade:</strong> {{ item.cidade || '-' }}</p>
                                    <p><strong>Área Tarifária:</strong> {{ item.areaTarifario === 'S' ? 'Dentro' :
                                        'Fora' }}</p>
                                </mat-card-content>
                            </mat-card>
    
                        </div>
                    </div> -->
            } @else {
            <div class="text-center py-8 text-gray-500">
                Nenhum itinerário cadastrado
            </div>
            }
        </div>
        }@else {
        <div class="flex justify-center items-center">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        }
    </div>

</div>